import React from "react";
import { MdInfo } from "react-icons/md";
import { t } from "i18next";

const InfoIcon = () => <MdInfo className="w-16 h-16 text-info" />;

export const getInfoDialogProps = (props) => ({
  className: "border-t-4 border-info-hover",
  titleClassName: "text-info-hover",
  textClassName: "text-info",
  image: props.image || <InfoIcon />,
  buttons: props.buttons || [
    {
      text: t("general.buttons.confirm"),
      variant: "primary",
    },
  ],
  ...props,
});

export default InfoIcon;
